module.exports = __webpack_public_path__ + "img/allaria-icon-large.a89089e5.png";